import React, { Component } from "react";

// Externals
import PropTypes from "prop-types";
import classNames from "classnames";

// Material helpers
import { Grid, withStyles } from "@material-ui/core";

// Material components
import { Divider, Typography } from "@material-ui/core";

// Component styles
const styles = theme => ({
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  company: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.5)
  },
  ppAndTosContainer: {
    maxWidth: "200px"
  },
  linkItem: {
    paddingBottom: theme.spacing(1)
  }
});

class Footer extends Component {
  render() {
    const { classes, className } = this.props;

    const rootClassName = classNames(classes.root, className);
    const year = new Date().getFullYear();
    return (
      <div className={rootClassName}>
        <Divider />
        <Typography className={classes.company} variant="body1">
          &copy; Responsum {year}
        </Typography>

        <Grid container className={classes.ppAndTosContainer}>
          <Grid item xs={12} sm={6} className={classes.linkItem}>
            <a href="http://responsum.ai/privacy-policy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.linkItem}>
            <a href="http://responsum.ai/tos" target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Footer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Footer);
